<template>
	<div v-if="event && event.eventable_type && event.id > 0">
		<!-- Entity detail section -->
		<v-list-item v-if="event.entity_title">
			<v-list-item-action>
				<v-icon :color="event.entity_color || 'primary'">
					{{ getEventableIcon(event.eventable_type) }}
				</v-icon>
			</v-list-item-action>
		
			<v-list-item-content>
				<v-list-item-title>{{ getEntityTypeLabel() }}</v-list-item-title>
				<v-list-item-subtitle>{{ event.entity_title }}</v-list-item-subtitle>
			</v-list-item-content>
			
			<v-list-item-action v-if="event.entity_route && event.entity_id">
				<v-btn 
					icon 
					@click="navigateToEntity()">
					<v-icon>mdi-chevron-right</v-icon>
				</v-btn>
			</v-list-item-action>
		</v-list-item>
	
		<!-- Priority section if entity has priority -->
		<v-list-item v-if="event.entity_priority !== null && event.entity_priority !== undefined">
			<v-list-item-action>
				<v-icon 
					:color="$eventBusUtility.priorityColor(event.entity_priority)">
					mdi-priority-high
				</v-icon>
			</v-list-item-action>
			<v-list-item-content>
				<v-list-item-title>Priorità</v-list-item-title>
				<v-list-item-subtitle>{{ event.entity_priority_text || '' }}</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
  	</div>
</template>

<script>
import CalendarMixin from '@/mixins/CalendarMixin'

export default {
  	name: 'EventableDetails',
  
	mixins: [CalendarMixin],
  
	props: {
		event: {
			type: Object,
			required: true
		}
	},
  
	methods: {
		getEntityTypeLabel() {
			switch(this.event.eventable_type) {
				case 'task': return this.$trans('task')
				case 'trouble': return this.$trans('trouble')
				case 'helpdesktrouble': return this.$trans('helpdesktrouble')
				case 'lead': return this.$trans('lead')
				case 'prospect': return this.$trans('prospect')
				case 'company': return this.$trans('company')
				case 'opportunity': return this.$trans('opportunity')
				default: return 'Elemento'
			}
		},
	
		navigateToEntity() {
			if (this.event.entity_route && this.event.entity_id) {
				this.$router.push(
					{ 
						name: this.event.entity_route + '-show', 
						params: { id: parseInt(this.event.entity_id) }
					}
				)
			}
		}
  	}
}
</script>